import React, { useState, useEffect } from 'react';
import { path, propOr, isEmpty } from 'ramda';
import { Page, Layout, Badge, TextStyle, Button, Card, AppProvider, Subheading, Heading } from '@shopify/polaris';
import '@shopify/polaris/dist/styles.css';

const JobSuccess = (props) => {
  let { path_url } = props;

  const changeRoute = path(['history', 'push'])(props);

  return (
    <AppProvider>
      <Page>
        <Card>
          <div className='Job-Success_content'>
            <Heading element='h1'> Success </Heading>
            <Subheading element='h2'> Thanks for subbmiting and application </Subheading>
            <Button onClick={() => changeRoute(`${path_url}`)} size='large'>
              View other openings
            </Button>
          </div>
        </Card>
      </Page>
    </AppProvider>
  );
};

export default JobSuccess;
